export default __webpack_public_path__ + "static/RootSans-12BlackItalic-027f88a77d5e926d79af6835d69c7f3f.woff";